module.exports = __webpack_public_path__ + "img/newswiper_6.5b3e69f7.png";